import React from 'react';
import HelmetHead from 'helmethead'; // see gatsby-node.js->webpack-config->resolve.alias... for resolution of this module

Head.defaultProps = {
  lang: `en`,
  title: ``,
  description: ``,
  image: undefined,
};

// 🎭 WEBEX: please do webex-specific changes to this Head in `src/webex/WebexHead.js`
export default function Head(props) {
  return <HelmetHead {...props} />;
}
